export type PointHistory = {
  historyId: number;
  category: PointCategory;
  title: string;
  transferInfo: string | null;
  addPoint: number;
  enabledAt: string;
  expiredAt: string;
  updatedAt: string;
  unspecifiedSubCategory: UnspecifiedSubCategory | null;
  logInfo: string;
};

// PointCategoryはポイント種別のカテゴリ
// UnspecifiedSubCategoryはUNSPECIFIEDカテゴリ専用のサブカテゴリとしてportland側で定義
// SEE: https://mo-t.atlassian.net/wiki/spaces/Aiauto/pages/1182236711/monaco.GetDriverPointHistory+-+Spec+-+API+-+-+GO
export type PointCategory =
  | "UNSPECIFIED"
  | "USER_TIP"
  | "USER_CANCEL_PAYMENT"
  | "PRIORITY_PASS"
  | "PICK_UP"
  | "RESERVATION"
  | "CARPOOL_PICK_UP"
  | "SALES_DISTRIBUTION"
  | "AWARD"
  | "CARPOOL_RESERVATION_COUNT"
  | "CARPOOL_LONG_PICKUP_DURATION";

export type UnspecifiedSubCategory = "Exchanged" | "Reverted" | "ErrorFee" | "Transfered" | "TransferReverted";

export type PointHistories = PointHistory[];

export const pointHistoriesDefaultValues: PointHistories = [];
